import { useEffect, useState } from "react";
import { Avatar } from "@mui/material";

const avatars = new Map<string, Promise<string | undefined>>();

export const loadChessComAvatar = (username: string): Promise<string | undefined> => {
  const key = username.trim().toLowerCase();
  if (!/^[\w-]{3,50}$/.test(key)) return Promise.resolve(undefined);
  const cached = avatars.get(key);
  if (cached) return cached;
  const request = fetch(`https://api.chess.com/pub/player/${encodeURIComponent(key)}`, { credentials: "omit" })
    .then(async (response) => {
      if (!response.ok) return undefined;
      const profile: unknown = await response.json();
      if (
        profile &&
        typeof profile === "object" &&
        "username" in profile &&
        (typeof profile.username !== "string" || profile.username.toLowerCase() !== key)
      )
        return undefined;
      if (!profile || typeof profile !== "object" || !("avatar" in profile) || typeof profile.avatar !== "string")
        return undefined;
      return new URL(profile.avatar).protocol === "https:" ? profile.avatar : undefined;
    })
    .catch(() => undefined);
  avatars.set(key, request);
  return request;
};

export const BoardPlayerAvatar = ({ username, src }: { username: string; src?: string }) => {
  const source = src?.length ? src : undefined;
  const [loaded, setLoaded] = useState<{ username: string; src: string | undefined }>();
  useEffect(() => {
    if (source || !username) return;
    let active = true;
    void loadChessComAvatar(username).then((avatar) => {
      if (active) setLoaded({ username, src: avatar });
    });
    return () => {
      active = false;
    };
  }, [username, source]);

  return (
    <Avatar
      component="span"
      variant="square"
      alt=""
      aria-hidden="true"
      src={source ?? (loaded?.username === username ? loaded.src : undefined)}
      sx={{
        display: "inline-flex",
        width: "1em",
        height: "1em",
        fontSize: "inherit",
        flexShrink: 0,
        bgcolor: "action.selected",
        color: "text.secondary",
      }}
    />
  );
};
